import axios from "axios";

// This API is for View Claim List - uses updateClaimStatus endpoint (auto sends email)
const endpoint_url = "/campaignV2/customer/luckyDraw/updateClaimStatus";

const updateClaimStatus = ({
  luckyDrawUuid,
  winnerUuid,
  winnerUuids,
  status,
  adminNotes,
}) => {
  // Backend expects numeric status:
  // 0 = CLAIM_PENDING_FULFILL (unprocessed)
  // 1 = CLAIM_COMPLETE_FULFILL (processed) - triggers email
  // 2 = CLAIM_REJECTED (rejected) - triggers email
  let statusValue;

  if (status === undefined || status === null) {
    statusValue = 0;
  } else if (typeof status === "string") {
    if (status === "processed") {
      statusValue = 1;
    } else if (status === "rejected") {
      statusValue = 2;
    } else if (status === "unprocessed") {
      statusValue = 0;
    } else {
      statusValue = parseInt(status, 10);
      if (isNaN(statusValue)) {
        statusValue = 0;
      }
    }
  } else if (typeof status === "number") {
    statusValue = Math.floor(status);
  } else {
    statusValue = 0;
  }

  // Final safety check - ensure status is a valid integer (0, 1, or 2)
  if (isNaN(statusValue) || statusValue < 0 || statusValue > 2) {
    statusValue = 0;
  }

  const body = {
    luckyDrawUuid,
    status: statusValue,
  };

  // Support both single winner (backward compatibility) and multiple winners
  if (winnerUuids && Array.isArray(winnerUuids)) {
    body.winnerUuids = winnerUuids;
  } else if (winnerUuid) {
    body.winnerUuid = winnerUuid;
  }

  // Add admin notes if provided
  if (adminNotes !== undefined && adminNotes !== null) {
    body.adminNotes = adminNotes;
  }

  return new Promise((resolve, reject) => {
    axios
      .post(endpoint_url, body)
      .then((response) => {
        if (response.data && response.data.success === false) {
          return reject(response.data);
        }
        resolve(response.data);
      })
      .catch((error) => {
        return reject(error.response?.data || error);
      });
  });
};

export default updateClaimStatus;
